
import {  jobOrderColNm } from "./jobOrderConstant"

export const creditNoteApiNm = {
  getCreditNote: "/credit-note/getCreditNote",
  getCreditNoteTable: "/credit-note/getCreditNoteTable",
  generateCreditNoteNo: "/branch/generateCreditNoteNo",
  insertCreditNote: "/credit-note/insertCreditNote",
  insertCreditNoteWithItem: "/credit-note/insertCreditNoteWithItem",
  updateCreditNoteColumn: "/credit-note/updateCreditNoteColumn",
  deleteCreditNote: "/credit-note/deleteCreditNote"
}


export const creditNoteColNm =  {
  CNId: "รหัสใบลดหนี้",
  CNDte: "วันที่ใบลดหนี้",
  CNNo: "เลขที่ใบลดหนี้",
  CNTxt: "สาเหตุการลดหนี้",
  OldAmnt:"มูลค่าตามเอกสารเดิม",
  NewAmnt: "มูลค่าที่ถูกต้อง",
  WhtPr: "หัก ณ ที่จ่าย",
  SumTotal: "มูลค่าลดหนี้รวม",
  InvNo: "อ้างอิงใบแจ้งหนี้",
  CusId: "ลูกค้า",
  Rmk: "หมายเหตุ",
  OwnRcptAmnt: "ใบเสร็จบริษัท",
  CusRcptAmnt: "ใบเสร็จลูกค้า",
  CusSNm: jobOrderColNm.CusSNm,
  BillNm: "ชื่อลูกค้า",
  BillAddr: "ที่อยู่",
  BillTaxId: "เลขประจำตัวผู้เสียภาษี",
  ModDte: "วันที่แก้ไข",
  ModAcc: "ผู้แก้ไข",
}

export const creditNoteItemColNm = {
  Dtl: "ชื่อรายได้",
  Qty: "จำนวน",
  UntPr: "ราคา/หน่วย(บาท)",
  Total: "มูลค่า(บาท)", 
  IsOwnRcpt: "ประเภทใบเสร็จ",
  WhtPrct: "หัก ณ ที่จ่าย", 
  VatPrct: "Vat"
}